module.exports = __webpack_public_path__ + "653f4e2899945805f6be0bf46520df76.svg";